import { put } from 'redux-saga/effects';
import { reset } from 'redux-form';
import { videoCommentAddErrorAction, videoCommentAddSuccessAction, videoCommentsFetchRequestAction } from '../actions';
import { commentModel } from 'common/api/models';
import { addVideoCommentApi } from 'common/api';

export function* addVideoCommentEffect({ payload }) {
  const comment = commentModel(payload);

  try {
    yield addVideoCommentApi(payload.video.id, comment);

    //reset form
    yield put(reset('commentsForm'));

    yield put(videoCommentAddSuccessAction());

    //reload new comments
    yield put(videoCommentsFetchRequestAction(payload.video.id));
  } catch (error) {
    yield put(videoCommentAddErrorAction());
  }
}
